export default __webpack_public_path__ + "static/media/logo_ba_font_02.b49950f9.png";